<template>
  <div>
    <card>
        <div class="row" style="margin-bottom:10px">
            <div class="col">
                <p>rischio: {{rischio}}</p>
            </div>
        </div>
    </card>

  </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
        Card
    },

    data() {
        return {
              
            rischio: null,
            idCliente: null,
        }
    },
    methods: {
        aggiornaRischio: async function() {
            let errore = 0;
            await AntiriciclaggioServices.updateRischio(this.idCliente)
            .then(response => { this.rischio= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.aggiornaRischio(); }
            }
            console.log(`rischio:`);
            console.log(this.rischio);
        },
        

        main: async function() {
            axios.defaults.withCredentials = true;
            this.idCliente = this.$route.query.idCliente;
            this.access_token = localStorage.getItem('access_token');
            try {
                await this.aggiornaRischio();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                    await Services.refreshTokenFunction();
                }
            }
        }
    },
    
    mounted() {
        this.main();
    }
};
</script>
<style scoped>
    label {
        font-size: 16px;
    }
    span {
        font-size: 100%;
    }
</style>
